module.exports = __webpack_public_path__ + "static/12-90d64decaf313994b38282024df78dfc.png";